// @ts-check
"use strict";

/**
 * Truncate a string to a given length, placing the
 * truncation marker in the middle of the string.
 * @method truncateMiddle
 * @param {string} fullStr The string to truncate
 * @param {{length?: number, omission?: string}} options The options object
 * @returns {string} The truncated string
 */
export const truncateMiddle = (fullStr = "", { length, omission } = {}) => {
  const strLen = length ?? 30;
  omission = omission ?? "...";
  fullStr = fullStr ?? "";

  if (fullStr.length <= strLen) {
    return fullStr;
  }

  const sepLen = omission.length;
  const charsToShow = strLen - sepLen;
  const frontChars = Math.ceil(charsToShow / 2);
  const backChars = Math.floor(charsToShow / 2);

  return `${fullStr.substring(0, frontChars)}${omission}${fullStr.substring(
    fullStr.length - backChars,
  )}`;
};
